import { Controller } from "@hotwired/stimulus"
import Honeybadger from "@honeybadger-io/js"

// Controls trade bar click events to open the trade details drawer
export default class extends Controller {
  static values = {
    taskId: Number,
    tradeId: Number,
  }

  openDrawer(event) {
    // Don't open drawer if clicking on resize handles
    if (event.target.closest("[data-plantafel-trade-resize-target]")) {
      return
    }

    // Prevent event from bubbling
    event.stopPropagation()

    const csrfToken = document.head
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content")
    const viewStartDate = this.getViewStartDate()
    const viewMode = this.getViewMode()
    const url = `/plantafel/tasks/${this.taskIdValue}/trades/${this.tradeIdValue}/details?view_start_date=${viewStartDate}&view_mode=${viewMode}`

    // Show loading cursor
    document.body.style.cursor = "wait"

    fetch(url, {
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then(async (response) => {
        const contentType = response.headers.get("Content-Type") || ""
        const html = await response.text()

        if (contentType.includes("text/vnd.turbo-stream.html")) {
          Turbo.renderStreamMessage(html)
        } else {
          // If not turbo stream, inject the HTML directly
          this.injectDrawer(html)
        }
      })
      .catch((error) => {
        Honeybadger.notify(error, {
          context: { component: "plantafel-trade-bar", action: "open_drawer" },
        })
      })
      .finally(() => {
        document.body.style.cursor = ""
      })
  }

  injectDrawer(html) {
    // Remove existing drawer if present
    const existingDrawer = document.getElementById("plantafel_trade_drawer")
    if (existingDrawer) {
      existingDrawer.remove()
    }

    // Find or create drawer container
    let container = document.getElementById("plantafel_drawer_container")
    if (!container) {
      container = document.createElement("div")
      container.id = "plantafel_drawer_container"
      document.body.appendChild(container)
    }

    container.innerHTML = html
  }

  getViewStartDate() {
    // First try to get from parent plantafel controller's data attribute
    const plantafelContainer = document.querySelector("[data-plantafel-current-date-value]")
    if (plantafelContainer) {
      return plantafelContainer.dataset.plantafelCurrentDateValue
    }

    // Fallback to URL param
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get("date") || this.formatDateForApi(new Date())
  }

  getViewMode() {
    // First try to get from parent plantafel controller's data attribute
    const plantafelContainer = document.querySelector("[data-plantafel-view-mode-value]")
    if (plantafelContainer) {
      return plantafelContainer.dataset.plantafelViewModeValue
    }

    // Fallback to URL param
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get("view") || "vertical_month"
  }

  formatDateForApi(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }
}
